'use client'

import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { ViewLandingPageEvent } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'
import { Screen } from 'constants/tracking/screens'

import IntroductionSection from './IntroductionSection/IntroductionSection'
import TaxRulesSection from './TaxRulesSection/TaxRulesSection'
import ApplySection from './ApplySection/ApplySection'
import HowItWorksSection from './HowItWorksSection/HowItWorksSection'
import CheckStatusSection from './CheckStatusSection/CheckStatusSection'
import LinksSection from './LinksSection/LinksSection'
import { UK_REPORTING } from '../../../constants/routes'

const UkReporting = () => {
  const { track } = useTracking()

  useEffect(() => {
    track(
      ViewLandingPageEvent({
        screen: Screen.Dac7,
        path: UK_REPORTING,
        referrer: document.referrer ? new URL(document.referrer).href : 'unknown',
      }),
    )
  }, [track])

  return (
    <div className="dac7__wrapper">
      <IntroductionSection />
      <TaxRulesSection />
      <ApplySection />
      <HowItWorksSection ukVersion />
      <CheckStatusSection ukVersion />
      <LinksSection />
    </div>
  )
}

export default UkReporting
